import { createReducer, on } from '@ngrx/store';
import {
  changeNadajPrzesylkeTyp,
  changeScreen,
  changeSposobDoreczeniaTyp,
  changeSposobNadaniaStepNumber,
  changeSposobNadaniaTyp,
} from './navigation.actions';
import { initialState } from './navigation.state';

export const navigationReducer = createReducer(
  initialState,
  on(changeNadajPrzesylkeTyp, (state, { nadajPrzesylkeTyp }) => ({
    ...state,
    nadajPrzesylkeTyp: nadajPrzesylkeTyp,
  })),
  on(changeScreen, (state, { screen }) => ({
    ...state,
    screen: screen,
  })),
  on(changeSposobNadaniaTyp, (state, { sposobNadaniaTyp }) => ({
    ...state,
    sposobNadaniaTyp: sposobNadaniaTyp,
  })),
  on(changeSposobDoreczeniaTyp, (state, { sposobDoreczeniaTyp }) => ({
    ...state,
    sposobDoreczeniaTyp: sposobDoreczeniaTyp,
  })),
  on(changeSposobNadaniaStepNumber, (state, { sposobNadaniaStepNumber }) => ({
    ...state,
    sposobNadaniaStepNumber: sposobNadaniaStepNumber,
  }))
);
